import styled from 'styled-components';

export const AccordionWrapper = styled.div`
  margin-bottom: 0.15rem;
`;

export const AccordionToggle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #9a99a1;
  padding: 0.6rem 1.25rem;
  cursor: pointer;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transition: color 0.15s ease;

  &:hover {
    color: #d1d1d1;
  }
`;

export const AccordionTitle = styled.span`
  font-weight: 600;
`;

export const AccordionChevron = styled.span`
  font-size: 0.65rem;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s ease;
`;

export const AccordionContent = styled.div`
  overflow: hidden;
  max-height: ${({ isOpen }) => (isOpen ? '500px' : '0')};
  padding: ${({ isOpen }) => (isOpen ? '0 0.5rem 0.4rem' : '0 0.5rem')};
  transition: max-height 0.3s ease, padding 0.2s ease;
`;
